import { Controller, useForm } from "react-hook-form";
import { zodResolver } from "@hookform/resolvers/zod";
import PasswordChecker from "components/password-and-confirm-password/passwordcheckerversion2/PasswordCheckerVersion2";
import { Button } from "components/ui/button/Button";
import Form from "components/ui/form/Form";
import "./update-password.scss";
import { z } from "zod";
import { password_input } from "utilities/formSchemas";
import { useEffect, useState } from "react";
import { ErrorType } from "utilities/error";
import { useNavigate } from "react-router-dom";
import { UpdatePasswordRequest, usePatchUpdatePasswordMutation } from "pages/recover-password/recoverPasswordService";
import { LoadingOverlay } from "components/ui/loading-spinners";
import { getCurrentUserId, setCredentials, setIsLogin } from "features/authSlice";
import { useDispatch, useSelector } from "react-redux";

const formSchema = z.object({
  password_input: password_input,
});

export default function UpdatePassword() {
  const {
    control,
    handleSubmit,
    formState: { dirtyFields, errors },
  } = useForm({ resolver: zodResolver(formSchema) });
  const ispasswordFieldModified = (dirtyFields.password_input as boolean) || false;
  const hasErrors = !!Object.keys(errors).length;
  const [isBtnDisabled, setIsBtnDisabled] = useState(true);
  const [error, setError] = useState(0);
  const [hasPwdError, setHasPwdError] = useState(false);
  const navigate = useNavigate();
  const userId = useSelector(getCurrentUserId);
  const [sendRequest, { data, isSuccess, isLoading }] = usePatchUpdatePasswordMutation();
  const onSubmit = (data: UpdatePasswordRequest) => {
    if (!hasErrors && !hasPwdError) {
      sendRequest(data)
        .unwrap()
        .catch((error: ErrorType) => {
          if (error.status == 409) {
            navigate("/", { replace: true });
          } else {
            setError(500);
          }
        });
    }
  };
  const dispatch = useDispatch();

  useEffect(() => {
    if (isSuccess && data) {
      dispatch(setIsLogin(true));
      dispatch(
        setCredentials({
          accessToken: data.accessToken,
          refreshToken: data.refreshToken,
          name: data.name,
          id: data.id,
          status: data.status,
          version: data.version,
        })
      );
      navigate("/my-loans", { replace: true });
    }
  }, [isSuccess, data, dispatch, navigate]);
  if (isLoading) return <LoadingOverlay text="Loading..." />;
  return (
    <div className="password-update">
      <div className="password-update--header">
        <span className="password-update--header__text1">Reset password</span>
        <p className="password-update--header__text2">This will update your previous password</p>
      </div>{" "}
      <div className="password-update__form">
        <Form
          onSubmit={handleSubmit((data) => {
            onSubmit({
              userId: userId,
              password: data.password_input as string,
            });
          })}
        >
          <div className="row--item">
            <Controller
              name="password_input"
              control={control}
              render={({ field: { onChange } }) => (
                <PasswordChecker
                  onChange={onChange}
                  checkErrors={ispasswordFieldModified}
                  createLabel="Password"
                  setHasPasswordError={setHasPwdError}
                  setBtnVisible={setIsBtnDisabled}
                  createPasswordPlaceholderName="New password"
                />
              )}
            />
          </div>
          <Button title="Continue" disabled={isBtnDisabled} />
        </Form>
      </div>
    </div>
  );
}
